import {commonTypes} from '../../actions/deploy-queue';

const defaultState = {
    dbState: {},
    updated: {},
    deleted: []
};

/**
 * This reducer is built to be reusable across data models.
 * - Primary Key in action allows us to ingest diversely keyed information
 * - The various actions are intended to support local and persistent updates allowing for the continued support of deferred save structures.
 * @param state
 * @param action {{type: action slug, primaryKey: primaryKey of the data set, response: the action payload}}
 * @returns {{dbState, deleted, updated}}
 */
const reducer = (state = defaultState, action) => {
    let newState = state;

    let primaryKey = 'uuid';
    if (typeof action.primaryKey === 'string') {
        primaryKey = action.primaryKey;
    }
    switch(action.type) {
        case commonTypes.FETCH_ALL_SUCCESS:
            newState = {
                ...state,
                ...{dbState: action.response.reduce((agg, v, i) => {
                        agg[v[primaryKey]] = v;
                        return agg;
                    }, {})}
            };
            return newState;
        case commonTypes.INSERT_SUCCESS:
        case commonTypes.UPDATEONE_SUCCESS:
            // In theory the below reducer should also use configs primary key
            newState = {
                ...state,
                ...{dbState: {
                        ...state.dbState,
                        ...{[action.response[primaryKey]]: action.response}
                    }
                },
            };
            return newState;
        case commonTypes.UPDATEONE_LOCAL_SUCCESS:
            newState = {
                ...state,
                ...{updated: {
                        ...state.updated,
                        ...{[action.response[primaryKey]]: action.response}
                    }
                },
            };
            return newState;

        case commonTypes.DELETE_SUCCESS:
            // In theory the below reducer should also use configs primary key
            newState = {
                ...state,
                ...{dbState: Object.values(state.dbState)
                        .reduce((agg, v, i) => {
                            if (v[primaryKey] != action.response) {
                                agg[v[primaryKey]] = v;
                            }
                            return agg;
                        }, {})},
            };
            return newState;
        case commonTypes.DELETE_FAILURE:
            return state;
        case commonTypes.PURGE_SUCCESS:
            // TODO: Update state when returned in purge response
            return state;
        case commonTypes.PURGE_FAILURE:
            return state;

        // These cases are currently unimplemented
        // TODO: these
        case commonTypes.FETCH_ONE_SUCCESS:
        case commonTypes.FETCH_ONE_FAILURE:
        case commonTypes.INSERT_FAILURE:
        case commonTypes.UPDATEONE_FAILURE:
        case commonTypes.FETCH_ALL_FAILURE:
        default:
            return state;
    }
};

export default {
    defaultState,
    reducer
}